














































import { Vue, Component, Model, Emit } from "vue-property-decorator";
import { formRules } from "@/const/form-rules";
import User, { NewUserInfo } from "@/controller/user";

@Component
export default class AddUserPopup extends Vue {
  @Model("input", { type: Boolean, required: true })
  show!: boolean;

  name = "";
  email = "";
  password = "";
  role = "";

  userRoles = User.getUserRoles();

  formIsValid = true;
  rules = formRules;

  @Emit("input")
  emitClose() {
    return false;
  }

  @Emit("click")
  emitClick(): NewUserInfo {
    return {
      displayName: this.name,
      email: this.email,
      password: this.password,
      role: this.role
    };
  }

  onClick() {
    this.validateForm();

    if (this.formIsValid) {
      this.emitClick();
    }
  }

  private validateForm() {
    (this.$refs.form as Vue & { validate: () => boolean }).validate();
  }
}
